module.exports = __webpack_public_path__ + "img/1235.689c8544.gif";